import { render } from "./SchemaField.vue?vue&type=template&id=ff80c48e"
import script from "./SchemaField.vue?vue&type=script&lang=js"
export * from "./SchemaField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__